/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { logger as log } from '@common/logger';

import { Sttp } from '@common/sttp';
import { apiConfig } from '@/config/apiConfig';

export interface ISendOTPMethods extends IPluginMethodMap {
  sendOTP(args: {
    email: string;
    apiURL: string;
    sendOn: 'sms' | 'email' | 'both';
  }): Promise<any>;
}

export class SendOTPPlugin implements IAgentPlugin {
  readonly methods: ISendOTPMethods;
  constructor() {
    this.methods = {
      sendOTP: this.sendOTP.bind(this),
    };
  }

  async sendOTP(args: {
    email: string;
    apiURL: string;
    sendOn: 'sms' | 'email' | 'both';
  }) {
    return await this.getSendOtp(args);
  }

  private async getSendOtp(args: {
    email: string;
    apiURL: string;
    sendOn: 'sms' | 'email' | 'both';
  }) {
    try {
      let sttp = Sttp.withBaseUrl(apiConfig.rest.url);
      //  sttp =  sttp
      //     .withQueryParams({ page: 3 })
      //     .withHeaders({ 'X-API-Token': 123 })
      //     .withPayload({ name: 'Supercharge' })
      // const res = await sttp.post(`/your_url`);

      const res = await sttp.post(apiConfig?.sendOTPEP, {
        email: args?.email,
        sendOn: args?.sendOn,
      });
      if (res?.isError()) {
        log.error(
          `error in post status=${res.status()} statusText=${res.statusText()}`
        );
      }
      log.log('result of post=', res.data());
      return res.data();
    } catch (err: any) {
      log.error('error in post=', err?.message);
      throw err;
    }
  }
}
